import { ModalContext } from "../../components/BrowserAlert/modalContext";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import { termsOfUse } from "./termsOfUse";
import * as Yup from "yup";
import {
  Box,
  Button,
  Checkbox,
  Container,
  FormHelperText,
  TextField,
  Typography,
  Divider,
  Stack,
  Autocomplete,
  Tooltip,
  InputAdornment,
  InputLabel,
  Link,
} from "@common-ui/ui";
import { Business, AlternateEmail, Tv, Info } from "@mui/icons-material";
import { countries, createTopOrg, updateUserProfile } from "../../services";
import Dialog from "./Dialog";
import AlertDialog from "./AlertDialog";
import MandatoryIcon from "../../components/MandatoryIcon";

export const CreateOrgForm = () => {
  let { handleModal } = React.useContext(ModalContext);
  let router = useHistory();
  let orgsList = useSelector((state) => state.organization.organizations);

  const [privacyPolicy] = useState(termsOfUse);
  const [open, setOpen] = React.useState(false);
  const [currentOrgId, setCurrentOrgId] = React.useState(-1);

  const handleClickOpen = (orgId = -1) => {
    setCurrentOrgId(orgId);
    setOpen(true);
  };

  const handleClose = () => {
    router.push({
      pathname: `/orgs/${currentOrgId}/edit`,
    });
    setOpen(false);
  };

  // const router = useHistory();
  const formik = useFormik({
    initialValues: {
      orgName: "",
      orgHandle: "",
      orgDisplayName: "",
      orgCountryOrRegion: null,
      isAuthorized: false,
      privacyPolicy: false,
      termsOfUse: false,
    },
    validationSchema: Yup.object({
      orgName: Yup.string().trim().max(255).required("Name is required"),
      orgHandle: Yup.string().trim().max(255).required("Handle is required"),
      orgDisplayName: Yup.string().trim().max(255),
      orgCountryOrRegion: Yup.object()
        .nullable()
        .required("Country / Region is required"),
      privacyPolicy: Yup.boolean().oneOf([true], "This field must be checked"),
      termsOfUse: Yup.boolean().oneOf([true], "This field must be checked"),
      isAuthorized: Yup.boolean().oneOf([true], "This field must be checked"),
    }),
    onSubmit: () => {
      async function submit() {
        // console.log("formik", formik);
        let {
          orgName,
          orgHandle,
          orgDisplayName,
          orgCountryOrRegion,
          // isAuthorized,
          // privacyPolicy,
          // termsOfUse,
        } = formik.values;
        const attributes = {
          name: orgName,
          handle: orgHandle,
          screen_name: orgDisplayName,
          street_address: {
            address_line_1: " ",
            address_line_2: " ",
            city: " ",
            state_or_province: " ",
            country_or_region: orgCountryOrRegion?.label,
            postal_code: " ",
          },
        };
        try {
          const { payload } = await onSubmit(attributes);
          if (payload && orgsList.length === 0) {
            await updateUserProfile({ default_org: payload });
          }
          const orgId = payload;
          handleClickOpen(orgId);
          // alert(JSON.stringify(attributes));
          // router.push({
          //   pathname: `/verify-email`,
          // });
        } catch (error) {
          console.log(error.message);
          handleModal(
            `The handle "${orgHandle}" is already in use; Please use a different handle!"`,
            "Error"
          );
          formik.setSubmitting(false);
        }
      }
      submit();
    },
  });

  const onSubmit = async (attributes) => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      try {
        const payload = await createTopOrg(attributes);
        /* Once the user successfully signs up, update form state to show the confirm sign up form for MFA */
        resolve({ payload: payload?.id });
      } catch (error) {
        reject(error);
      }
    });
  };
  return (
    <>
      <Box
        component="main"
        sx={{
          alignItems: "center",
          display: "flex",
          flexGrow: 1,
          minHeight: "100%",
          backgroundColor: "#FFFFFF",
          ".MuiDataGrid-virtualScroller": {
            marginTop: "40px !important",
          },
          ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
          },
          // bgcolor: "background.paper",
        }}
      >
        <Container maxWidth="md" component="main">
          <form onSubmit={formik.handleSubmit}>
            <Box sx={{ my: 3, minHeight: "100%" }}>
              <Typography color="textPrimary" variant="h4">
                Main
              </Typography>
              <Typography color="textSecondary" gutterBottom variant="body2">
                Create New Organization
              </Typography>
            </Box>
            <Stack direction="column" sx={{ maxWidth: { md: 300 } }}>
              <div>
                {/* <Business position="end" /> */}
                <InputLabel>
                  <MandatoryIcon />
                  Company or Organization Name
                </InputLabel>
                <TextField
                  autoComplete="off"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Business />
                      </InputAdornment>
                    ),
                  }}
                  size="small"
                  error={Boolean(
                    formik.touched.orgName && formik.errors.orgName
                  )}
                  fullWidth
                  helperText={formik.touched.orgName && formik.errors.orgName}
                  placeholder="Type"
                  // label="Company or Organization Name"
                  margin="normal"
                  sx={{ mt: 1 }}
                  name="orgName"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.orgName}
                />
              </div>

              <div>
                <InputLabel sx={{ mt: 1 }}>
                  <MandatoryIcon />
                  @Org_handle{" "}
                  <span>
                    <Tooltip
                      placement="right"
                      title="For use in mentions i.e. @org_handle, you can use any
                    handle that is unique, and can choose to keep it
                    consistent to match your handle on other platforms e.g.
                    twitter."
                    >
                      <Info sx={{ fontSize: 14, color: "#777777" }} />
                    </Tooltip>
                  </span>
                </InputLabel>
                <TextField
                  size="small"
                  sx={{ mt: 1 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <AlternateEmail />
                      </InputAdornment>
                    ),
                  }}
                  autoComplete="off"
                  error={Boolean(
                    formik.touched.orgHandle && formik.errors.orgHandle
                  )}
                  fullWidth
                  helperText={
                    formik.touched.orgHandle && formik.errors.orgHandle
                  }
                  placeholder="Type"
                  margin="normal"
                  name="orgHandle"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.orgHandle}
                />
              </div>
              <div>
                <InputLabel sx={{ mt: 1 }}>
                  Display Name{" "}
                  <span>
                    <Tooltip
                      placement="right"
                      title="You can use a display name different from your
                        organization name, or you can leave this blank. You can
                        update your display name in your organization profile."
                    >
                      <Info sx={{ fontSize: 14, color: "#777777" }} />
                    </Tooltip>
                  </span>
                </InputLabel>
                <TextField
                  sx={{ mt: 1 }}
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Tv />
                      </InputAdornment>
                    ),
                  }}
                  autoComplete="off"
                  error={Boolean(
                    formik.touched.orgDisplayName &&
                      formik.errors.orgDisplayName
                  )}
                  fullWidth
                  helperText={
                    formik.touched.orgDisplayName &&
                    formik.errors.orgDisplayName
                  }
                  placeholder="Type"
                  margin="normal"
                  name="orgDisplayName"
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  type="orgDisplayName"
                  value={formik.values.orgDisplayName}
                  variant="outlined"
                />
              </div>
              <div>
                <InputLabel sx={{ mt: 1 }}>
                  {" "}
                  <MandatoryIcon />
                  Country / Region
                </InputLabel>
                <Autocomplete
                  id="country-select"
                  sx={{ mt: 1 }}
                  disablePortal
                  ListboxProps={{ style: { maxHeight: "200px" } }}
                  options={countries}
                  autoHighlight
                  size="small"
                  getOptionLabel={(option) => option.label}
                  margin="normal"
                  name="orgCountryOrRegion"
                  limitTags={4}
                  onBlur={formik.handleBlur}
                  onChange={(value, newValue) => {
                    formik.setFieldValue("orgCountryOrRegion", newValue);
                  }}
                  fullWidth
                  value={formik.values.orgCountryOrRegion}
                  renderOption={(props, option) => (
                    <Box
                      component="li"
                      sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                      {...props}
                    >
                      <img
                        loading="lazy"
                        width="20"
                        src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                        srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                        alt=""
                      />
                      {option.label} ({option.code}) +{option.phone}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      placeholder="Select"
                      helperText={
                        formik.touched.orgCountryOrRegion &&
                        formik.errors.orgCountryOrRegion
                      }
                      error={Boolean(
                        formik.touched.orgCountryOrRegion &&
                          formik.errors.orgCountryOrRegion
                      )}
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "off", // disable autocomplete and autofill
                      }}
                    />
                  )}
                />
              </div>
            </Stack>

            <Stack sx={{ maxWidth: { md: 600 } }}>
              <Divider sx={{ mb: 2, mt: 2 }} />
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  ml: -1,
                }}
              >
                <Checkbox
                  name="isAuthorized"
                  checked={formik.values.isAuthorized}
                  onChange={formik.handleChange}
                />
                <Typography color="textSecondary" variant="body2">
                  I verify that I am an authorized representative of this
                  organization and have the right to act on its behalf in the
                  creation and management of this account.
                  <MandatoryIcon />
                </Typography>
              </Box>
              {Boolean(
                formik.touched.termsOfUse && formik.errors.termsOfUse
              ) && (
                <FormHelperText error>
                  {formik.errors.termsOfUse}
                </FormHelperText>
              )}
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  ml: -1,
                }}
              >
                <Checkbox
                  name="termsOfUse"
                  checked={formik.values.termsOfUse}
                  onChange={formik.handleChange}
                />
                <Typography color="textSecondary" variant="body2">
                  I have read the and I accept the{" "}
                  <Dialog
                    formik={formik}
                    trigger={
                      <>
                        FLUKEWORKS<sup>TM</sup> MASTER SERVICES AGREEMENT
                      </>
                    }
                    content={privacyPolicy}
                    title={
                      <>
                        FLUKEWORKS<sup>TM</sup> MASTER SERVICES AGREEMENT
                      </>
                    }
                    // subTitle={"We are currently using Cubyt terms of use"}
                  />
                  <MandatoryIcon />
                </Typography>
              </Box>
              {Boolean(
                formik.touched.termsOfUse && formik.errors.termsOfUse
              ) && (
                <FormHelperText error>
                  {formik.errors.termsOfUse}
                </FormHelperText>
              )}
              <Box
                sx={{
                  alignItems: "center",
                  display: "flex",
                  ml: -1,
                }}
              >
                <Checkbox
                  name="privacyPolicy"
                  checked={formik.values.privacyPolicy}
                  onChange={formik.handleChange}
                />
                <Typography color="textSecondary" variant="body2">
                  I have read the and I accept the{" "}
                  <Link
                    href="https://www.fluke.com/en-us/fluke/privacy-policy"
                    target="_blank"
                    color="primary"
                    underline="always"
                    variant="subtitle2"
                  >
                    PRIVACY POLICY
                  </Link>
                  {/* <Dialog
                    formik={formik}
                    trigger={"PRIVACY POLICY"}
                    content={privacyPolicy}
                    title={"PRIVACY POLICY"}
                    // subTitle={"We are currently using Cubyt terms of use"}
                  /> */}
                  <MandatoryIcon />
                </Typography>
              </Box>
              {Boolean(
                formik.touched.privacyPolicy && formik.errors.privacyPolicy
              ) && (
                <FormHelperText error>
                  {formik.errors.privacyPolicy}
                </FormHelperText>
              )}
              <Divider sx={{ py: 1 }} />
              <Stack
                direction={{ xs: "column", md: "row" }}
                justifyContent="flex-end"
                spacing={{ xs: 1, md: 2 }}
                sx={{ py: 2 }}
              >
                <div>
                  <Button
                    color="primary"
                    // disabled={formik.isSubmitting}
                    fullWidth
                    size="large"
                    onClick={() => router.goBack()}
                    // type="submit"
                    variant="text"
                  >
                    Cancel
                  </Button>
                </div>
                <div>
                  <Button
                    color="primary"
                    disabled={!(formik.isValid && formik.dirty)}
                    fullWidth
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Save
                  </Button>
                </div>
              </Stack>
            </Stack>
          </form>
        </Container>
      </Box>
      <AlertDialog handleClose={handleClose} open={open} />
    </>
  );
};
